import { render, staticRenderFns } from "./SelecaoServicos.vue?vue&type=template&id=92733412"
import script from "./SelecaoServicos.vue?vue&type=script&lang=js"
export * from "./SelecaoServicos.vue?vue&type=script&lang=js"
import style0 from "./SelecaoServicos.vue?vue&type=style&index=0&id=92733412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports